import { breakpoints, spaces } from '@99designs/common/core/settings';
import { typography } from '@99designs/common/core/settings/colors';
import { fontFamilies, fontSizes, lineHeights } from '@99designs/common/core/settings/typography';
import { Matrix, MatrixItem } from 'common/components/Matrix';
import Mediabox from 'common/components/Mediabox';
import { Color } from 'projects/consts';
import React from 'react';
import styled from 'styled-components';
import ColorComponent from './Color';

interface Props {
    value: string;
    options: {
        value: string;
        title: string;
        label?: React.ReactElement | string;
    }[];
    onChange: (value: string) => void;
}

const smallViewportWidth = `${breakpoints.small[1]}px`;

const Box = styled.div`
    padding: ${spaces.halfGutter}px ${spaces.gutter}px;
    height: 125px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (max-width: ${smallViewportWidth}) {
        padding: ${spaces.halfGutter}px;
        height: auto;
    }
`;

const Title = styled.div`
    font-family: ${fontFamilies.heading};
    font-size: ${fontSizes.h5.medium}px;
    color: ${typography.root};
    line-height: ${lineHeights.h5};
    margin-bottom: ${spaces.quarterGutter}px;

    @media screen and (max-width: ${smallViewportWidth}) {
        font-size: ${fontSizes.h5.small}px;
    }
`;

const Label = styled.span`
    font-size: ${fontSizes.paragraphs.small}px;
    color: ${typography.soft};
`;

export default function BoxSelect({ options, value, onChange }: Props) {
    return (
        <Matrix large={2} medium={2} normal={2} small={1} staggered={false}>
            {options.map(option => (
                <MatrixItem key={option.value}>
                    <ColorComponent color={Color.createBlue}>
                        <Mediabox
                            variations={['linked', 'chameleon']}
                            selected={option.value === value}
                            onClick={() => onChange(option.value)}
                        >
                            <Box>
                                <Title>{option.title}</Title>
                                <Label>{option.label}</Label>
                            </Box>
                        </Mediabox>
                    </ColorComponent>
                </MatrixItem>
            ))}
        </Matrix>
    );
}
